export default {"src":"/_next/static/media/icon-profile.910b4b89.svg","height":20,"width":20};